import axios from "axios";
const apiAdder = process.env.VUE_APP_API;
export async function getList(_, filter) {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  return axios
    .post(`${apiAdder}transaction/filter/`, filter, config)
    .then((rsp) => {
      return rsp.data;
    });
}
export async function findUser(_, data) {
  const token = localStorage.getItem("token");
  return axios
    .post(`${apiAdder}user/find/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
export async function filter(_, data) {
  const token = localStorage.getItem("token");
  return axios
    .post(`${apiAdder}transaction/filter/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}

export async function creat(_, data) {
  const token = localStorage.getItem("token");
  return axios
    .post(`${apiAdder}transaction/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}

export async function getPolicy() {
  return axios.get(`${apiAdder}transaction/policy/`).then((rsp) => {
    return rsp.data;
  });
}
